import SparksSvg from "../../../assets/reactions/sparks.svg?react";
import BlossomSvg from "../../../assets/reactions/blossom.svg?react";
import CoolSvg from "../../../assets/reactions/cool.svg?react";
import HeartSvg from "../../../assets/reactions/heart.svg?react";
import OctopusSvg from "../../../assets/reactions/octopus.svg?react";
import * as styles from "../ReactionButton/ReactionButton.css.ts";

export const imageMapping = {
  "✨": SparksSvg,
  "🌱": BlossomSvg,
  "🆒": CoolSvg,
  "❤️": HeartSvg,
  "🐙": OctopusSvg,
};

export const ReactionIcon = ({ reaction }) => {
  const SvgComp = imageMapping[reaction];
  return (
    <div className={styles.reactionIcon}>
      {SvgComp ? <SvgComp className={styles.svg} /> : reaction}
    </div>
  );
};
